import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLElement
import kotlinx.browser.document

@Composable
fun HeaderSection() {
    Header({
        style {
            backgroundColor(Color("#333"))
            padding(16.px)
            color(Color.white)
            textAlign("center")
            property("box-shadow", "0px 2px 10px rgba(0, 0, 0, 0.2)")

            property("width", "100%")
            property("z-index", "10")
            property("height", "80px") // Set a fixed height for the header
            property("display", "flex")
            property("align-items", "center") // Center the content vertically
        }
    }) {
        // Portfolio Title
        H1({
            style {
                fontSize(28.px)
                fontWeight("bold")
                marginBottom(8.px)
                marginRight(16.px) // Add some spacing to the right
                fontFamily("Roboto, sans-serif")
            }
        }) { Text("Mahmoud Eraqi's Portfolio") }

        // Navigation
        Nav {
            Ul({
                style {
                    padding(0.px)
                    margin(0.px)
                    property("list-style-type", "none")
                    property("display", "flex") // Align navigation items in a row
                    property("justify-content", "center") // Center the nav items
                }
            }) {
                listOf("About", "Skills", "Projects", "Contact").forEach { section ->
                    Li({
                        style {
                            display(DisplayStyle.InlineBlock)
                            marginRight(20.px)
                        }
                    }) {
                        A(href = "#$section", attrs = {
                            style {
                                color(Color.white)
                                textDecoration("none")
                                padding(8.px)
                                borderRadius(4.px)
                                property("transition", "background-color 0.3s")
                            }
                            onClick {
                                scrollToSection(section)
                            }
                        }) { Text(section) }
                    }
                }
            }
        }
    }
}

fun scrollToSection(sectionId: String) {
    val element = document.getElementById(sectionId) as? HTMLElement
    element?.scrollIntoView()
}
